import React from "react";
import { FoiItem } from "../../domain/FoiItem";
import { AddNoteDialog } from "./dialogs/AddNoteDialog";
import { InternalMessageDialog } from "./dialogs/InternalMessageDialog";
import { AddEventDialog } from "./dialogs/AddEventDialog";
import { RecordEventCompletionDialog } from "./dialogs/RecordEventCompletionDialog";
import { DialogType, EntityDialog } from "./types";
import { useAuth } from "@ofqual/portal-core/core/hooks";
import { authSelector } from "../../redux/selectors";
import { UserType } from "../../redux/types";
import { PublicMessageDialog } from "./dialogs/PublicMessageDialog";

type RenderDialogProps = {
  focusedEntity: EntityDialog | null;
  onClose: () => void;
  foiItem: FoiItem;
};

export const RenderDialog: React.FC<RenderDialogProps> = ({
  focusedEntity,
  onClose,
  foiItem,
}) => {
  const { userType } = useAuth(authSelector);
  
  if (!focusedEntity) return null;

  const { dialogType } = focusedEntity;
  const activity = focusedEntity.focusedActivity!;
  // todo - check if a specific role is required
  const isAdmin = userType === UserType.Ofqual;

  switch (dialogType) {
    case DialogType.AddNote:
      return <AddNoteDialog onClose={onClose} resource={foiItem} />;
    case DialogType.AddInternalMessage:
      return <InternalMessageDialog onClose={onClose} resource={foiItem} />;
    case DialogType.AddEvent:
      return <AddEventDialog onClose={onClose} foiItem={foiItem} isAdmin={isAdmin} />;
    case DialogType.CompleteEvent:
      return <RecordEventCompletionDialog onClose={onClose} foiItem={foiItem} activity={activity} isAdmin={isAdmin} action="complete" />;
    case DialogType.CompleteEventApprove:
      return <RecordEventCompletionDialog onClose={onClose} foiItem={foiItem} activity={activity} isAdmin={isAdmin} action="approve" />;
    case DialogType.CompleteEventReject:
      return <RecordEventCompletionDialog onClose={onClose} foiItem={foiItem} activity={activity} isAdmin={isAdmin} action="reject" />;
    case DialogType.SendPublicMessage: 
      return <PublicMessageDialog onClose={onClose} resource={foiItem} />;
    default:
      return null;
  }
};
